import { Pagination, Stack } from "@mui/material";
import React from "react";

function Custom_Paingation(props) {
  const {
    selectedPage,
    totalPageCount,
    paginationError,
    inputPageValue,
    setSelectedPage,
    setPaginationError,
    setInputPageValue,
    onPageChange,
  } = props;

  return (
    <Stack spacing={2} className="Custom_Pagination">
      <Pagination
        count={totalPageCount}
        page={selectedPage}
        onChange={onPageChange}
        color="primary"
        className={`mt-0 ${paginationError ? "align-self-baseline" : ""}`}
      />
      <div className="flex-vertical">
        <div className="go-button-container">
          <span>Go to Page</span>
          <input
            id="pageInput"
            min={1}
            max={totalPageCount}
            value={inputPageValue}
            onChange={(e) => setInputPageValue(e.target.value)}
          />
          <span className="mx-1">/</span>
          {totalPageCount}
          <button
            className="create-btn"
            onClick={() => {
              // Update the selected page based on the input box value
              const inputPage = parseInt(
                document.getElementById("pageInput").value
              );
              if (
                !isNaN(inputPage) &&
                inputPage >= 1 &&
                inputPage <= totalPageCount
              ) {
                setPaginationError("");
                setSelectedPage(inputPage);
                setInputPageValue(inputPage);
                // Fetch data or update UI based on the new page
              } else {
                setPaginationError("Enter valid page number");
              }
            }}
          >
            Go
          </button>
        </div>
        {paginationError && (
          <p className="fnt-12px required">{paginationError}</p>
        )}
      </div>
    </Stack>
  );
}

export default Custom_Paingation;
